// deployment_class: customer_env_allowed
/**
 * Logout — revokes the server session (`/api/auth/sign-out`), clears local auth
 * state, then performs a HARD navigation to the login page. Plan 14 §Task 10 +
 * Task 11a.
 *
 * Why a hard navigation (`window.location.replace`) instead of SPA `navigate`:
 * a full document reload re-boots the app from a clean slate, so the very first
 * thing it does is re-read `/v3/auth/me` with the now-cleared cookie (→ 401 →
 * login). This eliminates ANY stale in-memory auth state surviving the sign-out
 * — the failure mode where the UI still looks logged-in after "Sign out".
 */
import { useEffect } from 'react';
import { useAuth } from './useAuth';

export function Logout(): JSX.Element {
  const { logout } = useAuth();

  useEffect(() => {
    void (async () => {
      await logout();
      window.location.replace('/auth/login');
    })();
  }, [logout]);

  return (
    <div className="min-h-screen bg-paper text-ink p-page">
      <p className="text-body-l text-warm-gray-d">Signing out…</p>
    </div>
  );
}
